(function () {
	'use strict';

	angular.module('dcApp').directive('projectMembersMapping', [
		'$parse',
		function ($parse) {
			var controller = [
				'$scope',
				'$rootScope',
				'DEV_BUILD',
				function ($scope, $rootScope, DEV_BUILD) {
					var vm = this;
					vm.userNameTruncateThresh = 20;
					// Raccourci de confort reserve au build de dev local.
					vm.showMappingShortcut = DEV_BUILD;
					vm.init = init;
					vm.initVmMembers = initVmMembers;
					vm.deleteMember = function (item) {
						if ($scope.displayedUsers.length > 0) {
							$scope.displayedUsers.splice(
								$scope.displayedUsers.indexOf(item),
								1
							);
						}
						if (vm.projectToImportInfos.members.length > 0) {
							vm.projectToImportInfos.members.splice(
								vm.projectToImportInfos.members.indexOf(item),
								1
							);
						}
					};

					$scope.querySearch = querySearch;

					$scope.selectUser = function (item) {
						if (item === null || item === undefined) {
							return;
						}
						$scope.selectedUsers.push({
							id: item.id,
							name: item.name,
							active: true,
							has_project_role: item.has_project_role,
							has_member_role: item.has_member_role,
							is_group: item.is_group,
							admin: false,
						});
					};

					$scope.addUser = function (item) {
						const result = $scope.displayedUsers.filter(
							(user) => user.member_id === item.id
						);
						if (result.length === 0) {
							$scope.displayedUsers.push({
								is_group: item.is_group,
								member_id: item.id,
								hasProjectRole: item.has_project_role,
								hasMemberRole: item.has_member_role,
								admin: item.admin,
								canDelete: true,
							});
							vm.members = $scope.displayedUsers;
						}
					};

					$scope.mapUser = mapUser;

					// Toutes les lignes pointent souvent vers le meme compte : on reporte
					// la correspondance choisie sur celles qui sont encore vides, sans
					// toucher a celles que l'utilisateur a deja renseignees.
					vm.applyTargetToEmptyRows = function (index) {
						var targetMember = vm.targetMembers[index];
						if (!targetMember) {
							return;
						}
						vm.projectToImportInfos.members.forEach(function (member, i) {
							if (i === index || vm.targetMembers[i]) {
								return;
							}
							vm.targetMembers[i] = targetMember;
							mapUser(targetMember, i);
						});
					};

					$scope.$watch(
						'displayedUsers',
						function (newValue) {
							if (
								newValue &&
								vm.from === 'import' &&
								vm.projectToImportInfos &&
								vm.projectToImportInfos.members &&
								vm.projectToImportInfos.members.length === 0
							) {
								vm.members = newValue;
							}
						},
						true
					);

					// La directive survit a la fermeture du modal : les correspondances
					// doivent repartir de zero quand une nouvelle archive est chargee.
					$scope.$watch(
						function () {
							return vm.projectToImportInfos
								? vm.projectToImportInfos.members
								: undefined;
						},
						function () {
							vm.targetMembers = [];
						}
					);

					function mapUser(targetMember, index) {
						vm.members[index].target_member_id = targetMember.id;
						vm.members[index].target_is_group = targetMember.is_group;
						vm.members[index].has_project_role = targetMember.has_project_role;
					}

					function querySearch(query) {
						return query ? vm.users.filter(createFilterFor(query)) : [];
					}

					function createFilterFor(query) {
						return function filterFn(user) {
							return (
								!_.find($scope.selectedUsers, function (item) {
									return item.id == user.id;
								}) && user.name.toLowerCase().indexOf(query.toLowerCase()) > -1
							);
						};
					}

					function initVmMembers(index) {
						let user = vm.projectToImportInfos.members[index];
						vm.members[index] = {
							imported_member_id: user.id,
							imported_is_group: !!user.name,
							admin: user.has_admin_role,
						};
					}

					function init() {
						vm.members = [];
						vm.targetMembers = [];
						vm.currentUser = _.find(vm.users, function (p) {
							return p.id === $rootScope.account.userId;
						});
						vm.currentUser = vm.currentUser ? vm.currentUser : {};
						vm.members = vm.users ? [] : $scope.displayedUsers;

						$scope.selectedUsers = [];
						$scope.isEmpty = Object.keys(vm.currentUser).length === 0;
						$scope.displayedUsers =
							$scope.isEmpty === false
								? [
										{
											is_group: vm.currentUser.is_group,
											member_id: vm.currentUser.id,
											hasProjectRole: vm.currentUser.has_project_role,
											hasMemberRole: vm.currentUser.has_member_role,
											admin: vm.currentUser.admin,
											canDelete: false,
										},
								  ]
								: [];
					}
				},
			];

			return buildDirectiveReturnObject(
				{
					from: '=',
					isNewVersion: '=',
					projectToImportInfos: '=',
					members: '=',
					users: '=',
					usage: '<',
				},
				controller,
				'./src/components/directives/duplicateProject/projectMembersMapping.html',
				function postLink(scope, element, attrs, $ctrl) {
					$ctrl.init();

					initElementForDirective(element, attrs, function () {});

					watchElementForDirective(
						element,
						scope,
						function () {
							return $ctrl.data ? $ctrl.data.showExportDatablock : false;
						},
						function () {},
						true
					);
				}
			);
		},
	]);
})();

